import { create } from "zustand";
import { WEB_PARAMS } from "../config/Constant";
import { fetchCityFromCoordinates } from "../api/homeApi";

const useLocationStore = create((set, get) => ({
  userLocation: (() => {
    const raw = localStorage.getItem(WEB_PARAMS.USER_LOCATION);
    try {
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  })(),
  cityName: localStorage.getItem(WEB_PARAMS.CITY_NAME) || "",
  stateName: localStorage.getItem(WEB_PARAMS.STATE_NAME) || "",
  isLocationLoading: false,
  locationError: null,

  /**
   * Updates the location and fetches the city name automatically.
   */
  updateLocation: async () => {
    if (!navigator.geolocation) {
      set({ locationError: "Geolocation not supported" });
      return;
    }

    set({ isLocationLoading: true, locationError: null });

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const coords = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };

        // Update coordinates in store and localStorage
        localStorage.setItem(WEB_PARAMS.USER_LOCATION, JSON.stringify(coords));
        set({ userLocation: coords });

        // Fetch city name from coordinates
        await get().fetchCity(coords);
      },
      (error) => {
        console.error("Geolocation error:", error);
        set({
          locationError: "Permission denied or failed to fetch position",
          isLocationLoading: false
        });
      }
    );
  },

  fetchCity: async (coords) => {
    set({ isLocationLoading: true });
    try {
      const { city, state } = await fetchCityFromCoordinates(coords);
      if (city) {
        localStorage.setItem(WEB_PARAMS.CITY_NAME, city);
        localStorage.setItem(WEB_PARAMS.STATE_NAME, state);
        set({ cityName: city, stateName: state, isLocationLoading: false });
      } else {
        set({ isLocationLoading: false });
      }
    } catch (error) {
      console.error("Error fetching city from coords:", error);
      set({ isLocationLoading: false });
    }
  },

  setCityName: (name) => {
    localStorage.setItem(WEB_PARAMS.CITY_NAME, name);
    set({ cityName: name });
  },

  setStateName: (name) => {
    localStorage.setItem(WEB_PARAMS.STATE_NAME, name);
    set({ stateName: name });
  },

  clearLocationError: () => set({ locationError: null }),
}));

export default useLocationStore;
